"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionType = void 0;

/**
 * The top-level actions an Event describes.
 *
 * Each ActionType corresponds with a table in Redshift.
 * @packageDocumentation
 */
let ActionType;
exports.ActionType = ActionType;

(function (ActionType) {
  ActionType["authImpression"] = "authImpression";
  ActionType["createdAccount"] = "createdAccount";
  ActionType["resetYourPassword"] = "resetYourPassword";
  ActionType["successfullyLoggedIn"] = "successfullyLoggedIn";
})(ActionType || (exports.ActionType = ActionType = {}));